module.exports = __webpack_public_path__ + "static/media/skade.7ae68fa1.m4a";